module.exports = __webpack_public_path__ + "assets/img/automatic1.47324b4f.jpg";